import { call, put } from "redux-saga/effects";

import { getInterestPointsTypesByCustomer as getInterestPointsTypesRequest } from "../services/points-of-interest";
import { Creators as interestActions } from "../actions/interestPoints";

export default function* getInterestPointsTypesByCustomer() {
  try {
    const list = yield call(getInterestPointsTypesRequest);
    yield put(interestActions.getInterestPointsTypesByCustomerSuccess(list));
  } catch (error) {
    yield put(interestActions.getInterestPointsTypesByCustomerFailure(error));
  }
}
